/* eslint-disable max-len */
// /* eslint-disable max-len */
import React,{useState,useContext} from 'react'
import { validateEmail } from '../../../../CommonMethods/EmailValidator';
import ErrorMessage from '../../../../components/ErrorMessage';
import GlobalContext from '../../../../components/Context/GloablContext';
import Loader from '../../../../components/Loader';
import {motion} from 'framer-motion'
import BannerImage from '../../../../components/BannerImage';
import AnimatedPage from '../../../../components/Animation/AnimatedPage';
import { userService } from '../../../../services/user.services';


export default function ForgotPassword({
    emptyError,
    setEmptyError,
    error,
    seterror,
    loading,
    setloading,
    loginError,
    setIsForgotPassword
}
) {
    const [invalidEmail, setInvalidEmail] = useState(false);
    const [usernameErr,setUsernameError]=useState(false)
    const [buttonClicked, setButtonClicked] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [inputTouched, setInputTouched] = useState(false);

    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext);
    const [email, setEmail] = useState('');

    function handleEmailChange(enteredEmail) {
        setErrorMessage('')
        if (!inputTouched) {
            // If the input hasn't been touched, do not perform validation
            return;
        }
        setInvalidEmail(validateEmail(enteredEmail));
        if(validateEmail(enteredEmail)) {
            setErrorMessage("Invalid username")
        } else {
            setErrorMessage("")
        }
        if (!enteredEmail) {
            setInvalidEmail(false);
            setErrorMessage("")
            setErrorMessage('');
        }
    }

    const resetRequestLink = async (e) => {
        e.preventDefault();
        setButtonClicked(true);
        const isEmailValid = validateEmail(email);
        if (isEmailValid) {
            setInvalidEmail(true);
            setErrorMessage("Invalid username")
            return;
        }
        setloading(true);
        try {
            const response = await userService.forgotPasswordLink(email);
            if (response.error===true&& response?.message?.response?.data?.message==="Reset request failed.") {
                // If there is an error, set isForgotPassword to true
                setIsForgotPassword(true);
                setErrorMessage('Incorrect username');
            } 
            else if(response.error===true){
                setIsForgotPassword(true);
                setErrorMessage(response?.message?.response?.data?.message);

            }else {
                // Handle the case when there is no error, if needed
                setToastmessage(response?.data?.message)
                // setToastmessage("Password reset link has been sent to your registered email address")
                setIsForgotPassword(false);
            }
        } catch (error) {
            setloading(false)
        }
        setloading(false);
        setButtonClicked(true);
    };

    return (
        <AnimatedPage>
            <div className='w-[35%] 2xl:w-[30%] pl-[30px] 2xl:pl-0'>
                <div className='w-[280px] xl:[290px] 2xl:w-[320px] flex flex-col justify-center items-center h-screen'>
                    <div className='w-full'>
                        <img src="/images/Arcm_login_logo.svg" alt="Banner-Img" className='w-fit h-fit mx-auto' />
                        <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>Forgot Password</h1>
                        <h1 className='text-lg font-normal text-[#000] text-center'>Please enter your username here</h1>
                        <form action="" className='mt-8' onSubmit={resetRequestLink}>
                            <div className='flex flex-col'>
                                <label htmlFor='email' className='text-xs font-semibold text-[#000] pb-1.5'>Username</label>
                                {/* border-[#D3454D] */}
                                <input type="text" id='userName' 
                                    value={email}
                                    onChange={(e)=>{
                                        setEmail(e.target.value)
                                        handleEmailChange(e.target.value)
                                    }} 
                                    onFocus={()=>{
                                        setButtonClicked(false)
                                        seterror(false)
                                        setToastErrorMessage("")
                                        setInvalidEmail(false)
                                        setErrorMessage("")
                                        setEmptyError(false)
                                        setErrorMessage(false)
                                    }}
                                    style={{border:`1px solid ${buttonClicked && (invalidEmail || errorMessage) ?'#C81720':'#C5C9DA'}`}}
                                    className='border border-[#C5C9DA] rounded-lg px-3.5 py-[11px] text-sm font-normal 
                                    text-[#000B17] w-full placeholder:text-[#52555D] outline-none focus:border-[#339D9E] 
                                    focus:shadow-s1' placeholder='Enter username' />
                            </div>
                            {/* {(buttonClicked && invalidEmail) && <p className='text-sm font-normal text-[#F04438] mt-2'>Invalid username</p>} */}
                            {errorMessage  && <ErrorMessage error message={errorMessage} />}
                            {/* {error && <ErrorMessage error  message={loginError}/>} */}
                            <button
                                id="reset_link"
                                disabled={loading || !email || !email.trim()}
                                className='w-full mt-8 py-2.5 px-2 text-lg font-semibold text-[#fff] rounded-[16px] 
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]'>
                                {!loading ? 'Request Reset Link' : <span>{<Loader />}</span>}
                            </button>
                        </form>
                    </div>  
                    <div className='flex justify-center w-full mt-6'>
                        <button onClick={() => {setIsForgotPassword(false),seterror(false),setEmptyError(false)}} className='flex items-center'>
                            <span className='text-lg font-normal text-[#008586] ml-3'>Back to Login</span>
                        </button>
                    </div> 
                </div>
            </div>
        </AnimatedPage>
    
    )
}
